import { baseFileName } from "./file-name-core.js";

export const JPG_PRESETS = Object.freeze({
  screen: Object.freeze({ dpi: 96, quality: .78 }),
  standard: Object.freeze({ dpi: 150, quality: .86 }),
  high: Object.freeze({ dpi: 220, quality: .92 })
});

export function jpgPageName(fileName, pageNumber, pageCount) {
  if (pageCount === 1) return `${baseFileName(fileName)}.jpg`;
  const digits = Math.max(3, String(pageCount).length);
  return `${baseFileName(fileName)}-page-${String(pageNumber).padStart(digits, "0")}.jpg`;
}

export function jpgZipName(fileName) {
  return `${baseFileName(fileName)}-jpg.zip`;
}
